// extracted by mini-css-extract-plugin
export default {"container":"random-colour_container__9DhXm","label":"random-colour_label__ywmrT"};